import React from 'react';
import styles from './M_ProgressBarPlant.module.css';
import { Q_Icon } from '@/components/Q_Quarks/Q_Icon/Q_Icon';
import A_ProgressBar from '@/components/A_Atoms/A_ProgressBar/A_ProgressBar';

interface M_ProgressBarPlantProps {
  progress: number;
}

export default function M_ProgressBarPlant({
  progress,
}: M_ProgressBarPlantProps) {
  const getStage = (progress: number) => {
    if (progress >= 0 && progress <= 25) return 1;
    if (progress >= 26 && progress <= 50) return 2;
    if (progress >= 51 && progress <= 75) return 3;
    if (progress >= 76 && progress <= 100) return 4;
    return 1;
  };

  const currentStage = getStage(progress);

  const getStageIcon = (stage: number) => {
    switch (stage) {
      case 1:
        return (
          <Q_Icon.TreePlantingStage1Icon width={50} height={50} fill='none' />
        );
      case 2:
        return (
          <Q_Icon.TreePlantingStage2Icon width={50} height={50} fill='none' />
        );
      case 3:
        return (
          <Q_Icon.TreePlantingStage3Icon width={50} height={50} fill='none' />
        );
      case 4:
        return (
          <Q_Icon.TreePlantingStage4Icon width={50} height={50} fill='none' />
        );
      default:
        return (
          <Q_Icon.TreePlantingStage1Icon width={50} height={50} fill='none' />
        );
    }
  };

  return (
    <div
      className={styles.wrapper}
      style={{ '--progress-percentage': progress } as React.CSSProperties}
    >
      <div className={styles.tree_icon_wrapper}>
        {getStageIcon(currentStage)}
      </div>
      <A_ProgressBar progress={progress} />
    </div>
  );
}
